import Vue from "vue"
import VueLazyload from "vue-lazyload"

Vue.use(VueLazyload, {
  preLoad: 1,
  attempt: 1,
  loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAQAAACx6dw/AAAAC0lEQVR42mNkAAMAAA4AAjOwv9wAAAAASUVORK5CYII=',

  lazyComponent: true
});
